/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerAccountControllerDtoNotificationsRemoveRequest model module.
 * @module model/ManagerAccountControllerDtoNotificationsRemoveRequest
 * @version 1.0
 */
class ManagerAccountControllerDtoNotificationsRemoveRequest {
    /**
     * Constructs a new <code>ManagerAccountControllerDtoNotificationsRemoveRequest</code>.
     * @alias module:model/ManagerAccountControllerDtoNotificationsRemoveRequest
     */
    constructor() { 
        
        ManagerAccountControllerDtoNotificationsRemoveRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ManagerAccountControllerDtoNotificationsRemoveRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerAccountControllerDtoNotificationsRemoveRequest} obj Optional instance to populate.
     * @return {module:model/ManagerAccountControllerDtoNotificationsRemoveRequest} The populated <code>ManagerAccountControllerDtoNotificationsRemoveRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerAccountControllerDtoNotificationsRemoveRequest();

            if (data.hasOwnProperty('notificationNo')) {
                obj['notificationNo'] = ApiClient.convertToType(data['notificationNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerAccountControllerDtoNotificationsRemoveRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerAccountControllerDtoNotificationsRemoveRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} notificationNo
 */
ManagerAccountControllerDtoNotificationsRemoveRequest.prototype['notificationNo'] = undefined;






export default ManagerAccountControllerDtoNotificationsRemoveRequest;

